/* eslint camelcase: "off" */
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import { graphql, compose, withApollo } from 'react-apollo';
import CacheUtil from '../common/utils/CacheUtil';
import DocumentIcon from './DocumentIcon';
import {
  DocumentBucketModal,
  PrepareEsignModal,
  RequestSentModal,
  EsignUrlModal,
  SignatureRequestReminderModal,
  RejectedModal,
  CancelEsignModal,
  SignatureRequestStatusModal,
  DeleteBucketModal,
  OrderTranscriptsModal,
} from './modals';
import Note from './Note';
import SuccessNotification from '../common/SuccessNotification';
import Modal from '../common/Modal';
import LoadingBar from '../common/LoadingBar';
import UploadContainer from './UploadContainer';
import WithLoan from '../shared/WithLoan';
//Queries and Mutations
import UpdateDocumentStatus from './queries/UpdateDocumentStatus';
import UpdateDocumentFileStatus from './queries/UpdateDocumentFileStatus';
import DocumentsQuery from './queries/DocumentsQuery';
import MarkFileAsRead from './queries/MarkFileAsRead';
import UpdateDocumentComment from './queries/UpdateDocumentComment';
import DocumentQuery from './queries/DocumentQuery';
import Regenerate1919sMutation from './mutations/Regenerate1919sMutation';
import Tooltip from '../common/Tooltip';

const ContainerBucket = styled.div`
  display: grid;
  grid-template-columns: 0fr 1fr;
  &:not(:last-child) {
    border-bottom: 1px solid #eeeeee;
  }
  margin: 20px 0;
`;
const ContainerInfo = styled.div`
  display: grid;
  padding: 0 20px;
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  min-width: 0;
  &:not(:last-child) {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
  }
`;
const LeftContainer = styled.div`
  border-right: 1px solid #eeeeee;
  padding-right: 10px;
  min-width: 0;
`;
const RightContainer = styled.div`
  margin-left: 16px;
`;
const DocumentControls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const StatusSelect = styled.select`
  max-width: 250px;
  margin-top: 5px;
`;
const File = styled.i`
  max-width: 85%;
  display: flex;
  justify-content: flex-start;
  color: #56565a;
`;
const Link = styled.a`
  color: #56565a;
  cursor: pointer;
  text-overflow: ellipsis;
  word-wrap: break-word;
  max-width: 90%;
  &:hover {
    color: #56565a;
  }
`;
const FileName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`;
const New = styled.div`
  padding: 0px 10px;
  background: #dd6a01;
  border-radius: 3px;
  color: white;
  font-size: 85%;
  height: 20px;
`;

const BlueText = styled.a`
  cursor: pointer;
  color: #75afb6;
  padding: 2px 0;
  &:hover {
    text-decoration: none;
    color: unset;
  }
`;
const LastSentText = styled.div`
  font-size: 12px;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  ${(props) => (props.disabled ? 'pointer-events: none;' : '')}
  padding: 10px;
  border: 1px solid transparent;
  margin-left: -10px;
  margin-bottom: 10px;
  color: ${(props) => (props.disabled ? 'darkgrey' : '#75AFB6')};
  &:hover {
    ${(props) => (props.disabled ? '' : 'border: 1px solid #75AFB6;')}
    border-radius: 3px;
  }
`;
const Grey = styled.p`
  justify-self: end;
  color: #cccccc;
`;
const TitleContainerReference = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin-bottom: 10px;
  b {
    margin-left: 10px;
    display: inline-block;
  }
`;

const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin-bottom: 10px;
  b {
    display: inline-block;
  }
`;
const Title = styled.div`
  margin-left: 10px;
  display: flex;
  justify-content: space-between;
`;

const Icon = styled.i`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #bd6228;
  color: white;
  visibility: hidden;
  padding: 3px;
  margin-left: 4px;
  cursor: pointer;
  display: inline-block;
  ${TitleContainer}:hover & {
    visibility: visible;
  }
`;

const DropdowContainer = styled.div`
  background: #fff;
`;

const RegenerateIcon = styled.i`
  font-size: 10pt;
`;

const Regenerate1919Button = styled.button`
  max-width: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #75afb6;
  background: #fff;
  padding: 6px;
  margin-left: 6px;
  cursor: pointer;
  display: inline-grid;
  border: 1px solid #fff;
  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:hover:enabled {
    border: 1px solid #75afb6;
  }
`;

const TooltipContainer = styled.div`
  display: inline-grid;
  position: relative;
  font-size: 13px;
  margin-left: 5px;
  text-align: center;
`;

const DisabledLinkHelper = styled.div`
  position: relative;
  color: darkgrey;
`;
const DisabledTooltip = styled.div`
  position: absolute;
  background: #4a4a4a;
  color: white;
  padding: 6px;
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  border-radius: 3px;
  font-family: 'Open Sans', sans-serif;
  white-space: nowrap;
  z-index: 999999;
  transition: all 0.15s ease;
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 4px;
    bottom: -16px;
    border-top: 10px solid #4a4a4a;
    border-bottom: 10px solid transparent;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }
  ${DisabledLinkHelper}:hover & {
    opacity: 1;
    transform: translate3d(0, -108%, 0);
  }
`;
const ErrorMessages = styled.div`
  color: #cc2626;
`;

const statusOptionsFile = {
  pending_review: 'Pending Review',
  conditionally_approved: 'Conditionally Approved',
  rejected: 'Rejected',
  approve_and_commit: 'Approve and Commit',
  move_to_archived: 'Move to Archived',
  un_archive: 'Un-Archive',
};

const statusOptions = {
  empty: 'Choose Status',
  ...statusOptionsFile,
  not_required: 'Not Required',
  esign_requested: 'E-Sign Requested',
};

class FinancialDocument extends Component {
  state = {
    documentStatus1919: 'idle',
    isChangingStatus: false,
    isDocumentBucketModalOpen: false,
    isRejectedModalOpen: false,
    isDeleteModalOpen: false,
    isPrepareEsignModalOpen: false,
    isUploading: false,
    isSuccessNotificationVisible: false,
    isRequestSentModalOpen: false,
    isEsignUrlModalOpen: false,
    isCancelEsignModalOpen: false,
    isSignatureRequestStatusModalOpen: false,
    isSignatureRequestReminderModal: false,
    isOrderTranscriptsModalOpen: false,
    is4506tLoading: false,
    lastRejectedRef: null,
    regenerate1919ButtonHover: false,
    errorMessage: '',
  };
  static propTypes = {
    client: PropTypes.object.isRequired,
    document: PropTypes.shape({
      adminOnly: PropTypes.bool,
      comment: PropTypes.string,
      confirmed: PropTypes.bool.isRequired,
      deletable: PropTypes.bool.isRequired,
      displayCommentable: PropTypes.bool.isRequired,
      esignable: PropTypes.bool.isRequired,
      esignReminderSentAt: PropTypes.string,
      files: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
      fileUrls: PropTypes.arrayOf(PropTypes.shape),
      live: PropTypes.bool.isRequired,
      name: PropTypes.string,
      rid: PropTypes.number.isRequired,
      skippable: PropTypes.bool.isRequired,
      skipped: PropTypes.bool.isRequired,
      status: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      uploaded: PropTypes.bool.isRequired,
    }),
    entityId: PropTypes.number.isRequired,
    idx: PropTypes.number,
    resourceType: PropTypes.string.isRequired,
    superUser: PropTypes.bool,
  };
  toggleState = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };
  toggleSuccessNotification = () => {
    const { isSuccessNotificationVisible } = this.state;

    if (this.successNotificationTimeout && isSuccessNotificationVisible) {
      clearTimeout(this.successNotificationTimeout);
      this.successNotificationTimeout = null;
    }
    this.toggleState('isSuccessNotificationVisible');
  };
  flashSuccessNotification = () => {
    this.setState({ isSuccessNotificationVisible: true });
    this.successNotificationTimeout = setTimeout(() => {
      this.setState({ isSuccessNotificationVisible: false });
    }, 4000);
  };
  changeStatus = (status) => {
    this.setState({ status });
  };
  updateDocumentData = (documentData, store, loanState, currentStatus) => {
    const { entityId, loanId, resourceType, guarantors, document, loan } =
      this.props;
    const shouldReload =
      loanState === 'forms_verified' &&
      window.location.pathname.includes('verify_forms');
    if (shouldReload) {
      return this.directUrlToGlobalSearchPage(loan.appNumber);
    }
    const { rid } = document;
    const data = store.readQuery({
      query: DocumentsQuery,
      variables: { rid: loanId },
    });
    if (data.loan) {
      const { affiliates, businesses } = data.loan;
      const business =
        this.getEntity(businesses, entityId) ||
        this.getEntity(affiliates, entityId);
      const guarantor = this.getEntity(guarantors, entityId);
      let entity;
      if (business) {
        entity = business;
      } else if (guarantor) {
        const businessEntity = this.getEntity(
          businesses,
          guarantor.business.rid
        );
        entity = this.getEntity(businessEntity.guarantors, entityId);
      }
      const collection =
        resourceType === 'Archived'
          ? entity.archivedDocuments
          : entity.documents;
      this.updateDocumentByIndex(collection, rid, currentStatus, documentData);
      store.writeQuery({
        query: DocumentsQuery,
        variables: { rid: loanId },
        data,
      });
      const entities = guarantors.concat(businesses);
      const reloadOnCreditMemoEntered =
        loanState === 'credit_memo_entered' &&
        this.documentsConfirmed(entities);
      if (reloadOnCreditMemoEntered) {
        return this.directUrlToGlobalSearchPage(loan.appNumber);
      }
    }
  };
  documentsConfirmed = (entities) => {
    const allDocuments = entities.reduce((allDocs, { documents }) => {
      return allDocs.concat(documents);
    }, []);

    return allDocuments.every(({ status }) =>
      ['approve_and_commit', 'not_required'].includes(status)
    );
  };
  directUrlToGlobalSearchPage = (loanAppNumber) => {
    window.location.reload();

    return `/admin/loans/${loanAppNumber}`;
  };
  getEntity = (entities, entityId) =>
    entities.find((entity) => entity.rid === entityId);
  updateDocumentByIndex = (documents, rid, status, documentData) => {
    const index = documents.findIndex((document) => document.rid === rid);
    if (index > -1) {
      this.updateDocumentList(documents, status, index, documentData);
    }
  };
  updateDocumentList = (documents, status, index, documentData) => {
    if (status === 'move_to_archived' || status === 'un_archive') {
      documents.splice(index, 1);
    } else {
      documents[index] = documentData;
    }
  };
  onStatusFileChange = (e, reference) => {
    e.preventDefault();
    const { value } = e.target;
    this.updateStatusFile(value, reference);
  };
  checkBucketStatus = (reference, status) => {
    const { referenceFiles } = this.props.document;
    const arrayStatus = JSON.parse(referenceFiles).map(({ status }) => status);
    let value;
    let openReject = false;
    value = arrayStatus.includes('conditionally_approved')
      ? 'conditionally_approved'
      : value;
    value = arrayStatus.includes('pending_review') ? 'pending_review' : value;
    value = arrayStatus.includes('rejected') ? 'rejected' : value;
    if (
      arrayStatus.filter((s) => s === 'approve_and_commit').length ===
      arrayStatus.length
    ) {
      value = 'approve_and_commit';
    }
    if (status === 'rejected') {
      this.setState({ lastRejectedRef: reference });
      openReject = true;
    }
    this.updateStatusBucket(value, openReject);
  };

  update1919s = async () => {
    const { loanId, regenerate1919s } = this.props;

    const handleMutationResponse = ({ responseStatus }) => {

      this.setState((prevState) => ({ documentStatus1919: responseStatus }));
    }

   this.setState((prevState) => ({ documentStatus1919: 'loading' }));

   try {
    await regenerate1919s({
      variables: {
        input: {
          loanId,
        },
      },
      refetchQueries: [{ query: DocumentsQuery, variables: { rid: loanId } }]
    })
    handleMutationResponse({ responseStatus: 'success' })
  } catch(error) {
    handleMutationResponse({ responseStatus: 'error' });
    }

    setTimeout(() => {
      handleMutationResponse({ responseStatus: 'idle' })
    }, 3000);
   }

  updateStatusFile = async (value, reference) => {
    const { updateDocumentFileStatus, document: doc } = this.props;
    const { rid } = doc;
    const { date } = reference;
    await updateDocumentFileStatus({
      variables: {
        input: {
          documentId: rid,
          fileStatus: value,
          referenceDate: date,
        },
      },
      update: (
        store,
        {
          data: {
            updateDocumentFileStatus: { document },
          },
        }
      ) => {
        this.updateDocumentData(document, store);
      },
    });
    await this.checkBucketStatus(reference, value);
  };

  updateStatusBucket = async (value, openReject) => {
    const {
      updateDocumentStatus,
      updateDocumentComment,
      document: doc,
    } = this.props;
    const { status, rid: documentId } = doc;

    if (value === 'rejected' && openReject) {
      this.toggleState('isRejectedModalOpen');
    } else if (status !== value && status !== '1') {
      this.setState({ status: value });
      await this.toggleState('isChangingStatus');
      await updateDocumentStatus({
        variables: {
          input: {
            documentId,
            status: value,
          },
        },
        update: (
          store,
          {
            data: {
              updateDocumentStatus: { document, loanState },
            },
          }
        ) => {
          this.updateDocumentData(document, store, loanState, value);
        },
      }).catch((errors) => {
        const errorMessage = errors.message.replace(
          /^[A-Z][A-Za-z]*\serror:\s/g,
          ''
        );
        this.setState({ errorMessage });
      });
      if (value === 'approve_and_commit') {
        setTimeout(async () => {
          await updateDocumentComment({
            variables: {
              input: {
                documentId,
                comment: null,
              },
            },
            update: (
              store,
              {
                data: {
                  updateDocumentComment: { document },
                },
              }
            ) => {
              this.updateDocumentData(document, store);
            },
          });
        }, 100);
      }
      this.toggleState('isChangingStatus');
    }
  };
  onStatusChange = (e) => {
    const { value } = e.target;

    e.preventDefault();
    this.updateStatusBucket(value, true);
  };
  onFilenameClick = async (filename) => {
    const { markFileAsRead, document } = this.props;
    const { rid } = document;
    try {
      await markFileAsRead({
        variables: {
          input: {
            documentId: rid,
            fileName: filename,
          },
        },
        update: (
          store,
          {
            data: {
              markFileAsRead: { document },
            },
          }
        ) => {
          this.updateDocumentData(document, store);
        },
      });
      this.decrementNotificationCount();
    } catch (err) {
      console.log(err);
    }
  };
  decrementNotificationCount = () => {
    // Until the left sidebar is refactored in react, we need to grab it with getElementById and manually decrement the counter
    const { resourceType, idx, document } = this.props;
    const { files } = document;
    const newCount = files.filter((f) => f.isNew).length;
    const parseInner = (innerHTML) => {
      const [value] = innerHTML.split(' ');
      return parseInt(value, 10);
    };
    if (newCount === 0) {
      let notification;
      if (resourceType === 'Business') {
        const docsTab = document.getElementById(`business-docs-tab-${idx}`);
        notification = docsTab.querySelector('#new-business-docs-counter');
      } else if (resourceType === 'Guarantor') {
        notification = document.getElementById('new-guarantor-docs-counter');
      }
      if (notification) {
        const notificationCount = parseInner(notification.innerHTML);
        if (notificationCount === 1) {
          notification.remove();
        } else {
          notification.innerHTML = `${notificationCount - 1} New`;
        }
      }
    }
  };
  renderStatusIcon = () => {
    const { isChangingStatus } = this.state;
    const { status, uploaded } = this.props.document;
    let option;
    if (!uploaded) {
      option = {
        iconClass: 'cloud-upload',
        color: '#808080',
      };
    } else {
      const options = {
        empty: {
          iconClass: 'file-text-o',
          color: '#ce7019',
        },
        approve_and_commit: {
          iconClass: 'check',
          color: '#339952',
        },
        pending_review: {
          iconClass: 'file-text-o',
          color: '#ce7019',
        },
        rejected: {
          iconClass: 'ban',
          color: '#BC3C4B',
        },
        conditionally_approved: {
          iconClass: 'check',
          color: '#e0e8e9',
        },
        not_required: {
          color: '#808080',
          child: 'N/A',
        },
        esign_requested: {
          iconClass: 'pencil-square-o',
          color: '#AD3B72',
        },
      };
      option = options[status];
    }
    const { iconClass, color, child } = option;

    return (
      <DocumentIcon
        loading={isChangingStatus}
        className={`fa fa-${iconClass}`}
        color={color}
      >
        {child}
      </DocumentIcon>
    );
  };
  renderOptionsFiles = () => {
    const options = Object.keys(statusOptionsFile);

    return options.map((opt) => (
      <option key={opt} value={opt}>
        {statusOptionsFile[opt]}
      </option>
    ));
  };
  removeOption = (options, optionValue) => {
    const indexOfOptionValue = options.indexOf(optionValue);

    options.splice(indexOfOptionValue, 1);
  };
  renderOptions = () => {
    const {
      customerService,
      superUser,
      document: doc,
      resourceType,
    } = this.props;
    const { skippable, status, type, uploaded } = doc;

    const options = Object.keys(statusOptions);

    if (!customerService) {
      this.removeOption(options, 'move_to_archived');
    }

    const cannotArchive =
      (type !== 'Document::Custom' || resourceType === 'Archived') &&
      (!doc.canBeManuallyArchived || !uploaded);
    if (customerService && cannotArchive) {
      this.removeOption(options, 'move_to_archived');
    }

    const cannotUnArchive =
      type !== 'Document::Custom' && !doc.canBeManuallyArchived;
    if (resourceType !== 'Archived' || cannotUnArchive) {
      this.removeOption(options, 'un_archive');
    }

    if (status !== 'esign_requested') {
      this.removeOption(options, 'esign_requested');
    }

    return options.map((opt) => {
      const option = (
        <option key={opt} value={opt}>
          {statusOptions[opt]}
        </option>
      );

      if (opt !== 'approve_and_commit' && !uploaded && skippable) {
        return option;
      } else if (!uploaded && skippable) {
        return;
      }
      if (opt === 'empty' && status !== 'empty') {
        // Only show 'Choose Status' if document status is nil
        return;
      } else if (
        (type === 'Document::LienPerfection' || type === 'Document::Signed') &&
        opt === 'approve_and_commit'
      ) {
        return (
          <option key={opt} value={opt}>
            Upload After Funding
          </option>
        );
      } else if (
        status === 'approve_and_commit' &&
        !superUser &&
        opt !== 'approve_and_commit'
      ) {
        // only super users can change status if it is approve and commit
        return;
      } else if (opt !== 'not_required') {
        return option;
      } else if (skippable && opt === 'not_required') {
        // only render not required if the skippable flag is true
        return option;
      }
    });
  };
  renderStatus = (hasReferences) => {
    if (!hasReferences) {
      const {
        props: {
          superUser,
          document: { confirmed, status, uploaded, skippable },
        },
      } = this;

      if (confirmed && !superUser) {
        return <p>Approved and Committed</p>;
      } else if (
        !uploaded &&
        ['empty', 'pending_review'].includes(status) &&
        !skippable
      ) {
        return <p>No Documents Uploaded</p>;
      } else {
        return (
          <StatusSelect
            id='status_select'
            value={status}
            onChange={this.onStatusChange}
          >
            {this.renderOptions()}
          </StatusSelect>
        );
      }
    } else {
      return <div></div>;
    }
  };
  renderStatusFiles = (reference) => {
    const files = this.getFilenames(reference);

    if (files.length <= 0) {
      return <div>No Documents Uploaded</div>;
    }

    const { status } = reference;

    return (
      <StatusSelect
        id='status_select'
        value={status}
        onChange={(e) => this.onStatusFileChange(e, reference)}
      >
        {this.renderOptionsFiles()}
      </StatusSelect>
    );
  };
  getFilenames = (referenceFileDate) => {
    const { document } = this.props;
    const filteredFilenames = [];
    const { files } = document;

    if (!referenceFileDate || !document) {
      return files;
    }

    const { date } = referenceFileDate;

    files.map((file) => {
      if (moment(file.referenceDate).isSame(date, 'month')) {
        filteredFilenames.push(file);
      }
    });

    return filteredFilenames;
  };
  renderFilenames = (reference) => {
    const { rid, fileUrls } = this.props.document;

    return this.getFilenames(reference).map((file, i) =>
      this.renderFileLink(file)
    );
  };
  renderPrepareEsignModal = () => {
    const { isPrepareEsignModalOpen } = this.state;
    const { guarantors, loanId, document: doc } = this.props;
    return (
      <Modal top light isModalOpen={isPrepareEsignModalOpen}>
        <PrepareEsignModal
          toggleModal={() => this.toggleState('isPrepareEsignModalOpen')}
          toggleRequestSentModal={() =>
            this.toggleState('isRequestSentModalOpen')
          }
          toggleEsignUrlModal={() => this.toggleState('isEsignUrlModalOpen')}
          document={doc}
          loanId={loanId}
          guarantors={guarantors}
        />
      </Modal>
    );
  };
  renderCancelEsignModal = () => {
    const { isCancelEsignModalOpen } = this.state;
    const doc = this.props.document;
    return (
      <Modal light isModalOpen={isCancelEsignModalOpen}>
        <CancelEsignModal
          toggleModal={() => this.toggleState('isCancelEsignModalOpen')}
          document={doc}
        />
      </Modal>
    );
  };
  renderRequestSentModal = () => {
    const { isRequestSentModalOpen } = this.state;
    return (
      <Modal light isModalOpen={isRequestSentModalOpen}>
        <RequestSentModal
          toggleModal={() => this.toggleState('isRequestSentModalOpen')}
        />
      </Modal>
    );
  };
  renderEsignUrlModal = () => {
    const { isEsignUrlModalOpen } = this.state;
    const { guarantors, document } = this.props;
    if (!guarantors) {
      return;
    }
    const [guarantor] = guarantors;
    return (
      <Modal light isModalOpen={isEsignUrlModalOpen}>
        <EsignUrlModal
          toggleModal={() => this.toggleState('isEsignUrlModalOpen')}
          document={document}
          guarantor={guarantor}
        />
      </Modal>
    );
  };
  renderEditModal = () => {
    const { isDocumentBucketModalOpen } = this.state;
    return (
      <Modal light isModalOpen={isDocumentBucketModalOpen}>
        <DocumentBucketModal
          toggleModal={() => this.toggleState('isDocumentBucketModalOpen')}
          flashSuccessNotification={this.flashSuccessNotification}
          getMomentDate={this.getMomentDate}
          {...this.props}
        />
      </Modal>
    );
  };
  renderDeleteModal = () => {
    const { isDeleteModalOpen } = this.state;
    const { document: doc } = this.props;
    const { rid, name } = doc;
    return (
      <Modal light isModalOpen={isDeleteModalOpen}>
        <DeleteBucketModal
          name={name}
          rid={rid}
          toggleModal={() => this.toggleState('isDeleteModalOpen')}
          {...this.props}
        />
      </Modal>
    );
  };
  renderSignatureRequestStatusModal = () => {
    const { isSignatureRequestStatusModalOpen } = this.state;
    return (
      <Modal light isModalOpen={isSignatureRequestStatusModalOpen}>
        <SignatureRequestStatusModal
          document={this.props.document}
          toggleModal={() =>
            this.toggleState('isSignatureRequestStatusModalOpen')
          }
        />
      </Modal>
    );
  };
  renderSignatureRequestReminderModal = () => {
    const { isSignatureRequestReminderModal } = this.state;
    return (
      <Modal light isModalOpen={isSignatureRequestReminderModal}>
        <SignatureRequestReminderModal
          document={this.props.document}
          toggleModal={() =>
            this.toggleState('isSignatureRequestReminderModal')
          }
        />
      </Modal>
    );
  };
  renderRejectedModal = () => {
    const { document: doc } = this.props;
    const { isRejectedModalOpen, lastRejectedRef } = this.state;
    return (
      <Modal light isModalOpen={isRejectedModalOpen}>
        <RejectedModal
          document={doc}
          toggleModal={() => this.toggleState('isRejectedModalOpen')}
          toggleChangingStatus={() => this.toggleState('isChangingStatus')}
          changeStatus={this.changeStatus}
          lastRejectedRef={lastRejectedRef}
          getKeyRef={this.getKeyRef}
          generateHash={this.generateHash}
          updateDocumentData={this.updateDocumentData}
          updateNotes={this.updateNotes}
        />
      </Modal>
    );
  };
  renderOrderTranscriptsModal = () => {
    const { resourceType, entity, document: doc } = this.props;
    const { rid } = doc;
    const { isOrderTranscriptsModalOpen } = this.state;
    return (
      <Modal light isModalOpen={isOrderTranscriptsModalOpen}>
        <OrderTranscriptsModal
          resourceType={resourceType}
          close={() => this.toggleState('isOrderTranscriptsModalOpen')}
          entity={entity}
          documentId={rid}
          document={doc}
          updateDocumentFiles={this.updateDocumentFiles}
        />
      </Modal>
    );
  };
  getMomentDate = (date) => {
    return moment(date, 'YYYY-MM-DD');
  };
  getKeyRef = (date) => {
    return this.getMomentDate(date).format('MM_YYYY');
  };
  renderNote = (reference) => {
    const { updateNotes } = this.state;
    const { document: doc } = this.props;
    const { rid } = doc;
    let { referenceFiles } = doc;
    referenceFiles = JSON.parse(referenceFiles);
    return (
      <Note
        id={`borrower_note_${rid}_document`}
        updateDocumentData={this.updateDocumentData}
        referenceFiles={referenceFiles}
        reference={reference}
        getKeyRef={this.getKeyRef}
        updateNotes={updateNotes}
        {...this.props}
      />
    );
  };
  renderEsignControls = () => {
    const { esignable, status, esignReminderSentAt } = this.props.document;
    if (!esignable) {
      return;
    }
    if (status !== 'esign_requested') {
      return (
        <Fragment>
          <ButtonContainer
            id='prepare_for_esign'
            onClick={() => this.toggleState('isPrepareEsignModalOpen')}
          >
            Prepare for E-Sign
          </ButtonContainer>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <BlueText
            onClick={() =>
              this.toggleState('isSignatureRequestStatusModalOpen')
            }
          >
            E-Sign Status
          </BlueText>
          <BlueText
            onClick={() => this.toggleState('isSignatureRequestReminderModal')}
          >
            Send Reminder
          </BlueText>
          {esignReminderSentAt && (
            <LastSentText>
              <i>Last sent on {esignReminderSentAt}</i>
            </LastSentText>
          )}
          <BlueText
            id='cancel_esign_request'
            onClick={() => this.toggleState('isCancelEsignModalOpen')}
          >
            Cancel E-Sign Request
          </BlueText>
        </Fragment>
      );
    }
  };
  renderControls = (reference) => {
    const { disabled } = this.props;
    const { live } = this.props.document;
    const key = reference ? reference.date : '';
    if (live && !disabled) {
      return (
        <Fragment>
          {this.renderEsignControls()}
          <UploadContainer
            flashSuccessNotification={this.flashSuccessNotification}
            reference={reference}
            referenceKey={key}
            {...this.props}
          />
        </Fragment>
      );
    }
  };
  areTranscriptsOrderable = (props) => {
    const { entity, resourceType, loan } = props;
    if (resourceType === 'Business') {
      const { files } = props.document;
      // We should only be able to order bsuiness transcripts if there are
      // no files in the 4506t bucket
      return !(files.length > 0);
    } else if (resourceType === 'Guarantor') {
      if (
        entity.borrowerType === 'affiliate' ||
        (entity.borrowerType === 'corporate_guarantor' && !loan.cre)
      ) {
        // Transcripts aren't ordered for affiliates or corporate guarantors
        return false;
      }
      const business = CacheUtil.findOC(loan);
      const businessTranscriptOrder = business.documents.find(
        (d) => d.type === 'Document::T4506c'
      );
      if (!businessTranscriptOrder) {
        return false;
      }
      const spouse = CacheUtil.findSpouse(entity, loan);
      const taxReturn = this.getLatestTaxReturn(business);
      // We should only be able to order guarantor transcripts if business transcripts
      // have already been ordered (determined by the presence of a file in the bucket)
      if (taxReturn && taxReturn.formName === '1040C') {
        // If the business files on a 1040 we should not order guarantor transcripts
        return false;
      }
      if (!spouse) {
        return businessTranscriptOrder.files.length > 0;
      } else {
        return !spouse.orderId; // && businessTranscriptOrder.files.length === 0
      }
    }
  };
  isNoTranscriptsFlow = (props) => {
    return props.loan.noTranscriptsFlow;
  };
  getTooltipMessage = (props) => {
    const { loan, entity, resourceType, document: doc } = props;
    const { signed } = doc;
    const business = CacheUtil.findOC(loan);
    const isGuarantor = resourceType === 'Guarantor';
    const businessTranscriptOrder = business.documents.find(
      (d) => d.type === 'Document::T4506c'
    );
    const taxReturn = this.getLatestTaxReturn(business);
    const businessTranscriptsNeeded =
      businessTranscriptOrder &&
      businessTranscriptOrder.files.length === 0 &&
      isGuarantor;
    const is1040 = taxReturn && taxReturn.formName === '1040C' && isGuarantor;
    const spouseOrder = entity.spouseId && isGuarantor;
    if (businessTranscriptsNeeded) {
      return 'Business transcripts must be ordered before personal transcripts can be ordered';
    } else if (is1040) {
      return 'Guarantor transcripts do not need to be ordered if the business files on a 1040C';
    } else if (spouseOrder) {
      return 'This guarantor is married and shares a transcript order with their spouse';
    } else if (signed) {
      return 'The document has been signed and HelloSign is processing it. Please check back later';
    }
    return '';
  };

  getLatestTaxReturn = (business) => {
    const { taxReturns } = business;
    const sortedTaxes = taxReturns
      .slice()
      .sort(
        ({ year: yearA }, { year: yearB }) => parseInt(yearA) - parseInt(yearB)
      );

    return sortedTaxes.length > 0 && sortedTaxes.pop();
  };

  renderOrderTranscriptsButton = () => {
    const { entity, document: doc } = this.props;
    const { borrowerType } = entity;
    const { files } = doc;
    const { is4506tLoading } = this.state;
    const areTranscriptsOrderable = this.areTranscriptsOrderable(this.props);
    const showOrderButton = files.length === 0 && borrowerType !== 'affiliate';
    if (
      showOrderButton &&
      this.isNoTranscriptsFlow(this.props) &&
      !is4506tLoading
    ) {
      return (
        <ButtonContainer
          id='order_transcripts'
          onClick={() => this.toggleState('isOrderTranscriptsModalOpen')}
          disabled={!areTranscriptsOrderable}
        >
          Order Transcripts
        </ButtonContainer>
      );
    } else if (is4506tLoading) {
      return <LoadingBar barId='document_upload_loading_bar' visible />;
    }
  };
  updateDocumentFiles = (rid) => {
    // Poll server for changes to document files every 5 seconds
    const { client, entity, loan } = this.props;
    this.setState({ is4506tLoading: true });
    this.timeout = setTimeout(async () => {
      const { data } = await client.query({
        query: DocumentQuery,
        fetchPolicy: 'no-cache',
        variables: {
          rid,
        },
      });
      if (data.document.files.length > 0) {
        clearTimeout(this.timeout);
        const store = client.readQuery({
          query: DocumentsQuery,
          variables: {
            rid: loan.rid,
          },
        });
        CacheUtil.updateDocument(entity, data.document, store.loan);
        client.writeQuery({
          query: DocumentsQuery,
          variables: { rid: loan.rid },
          data: store,
        });
        this.setState({ is4506tLoading: false });
      } else {
        this.updateDocumentFiles(rid);
      }
    }, 5000);
  };
  renderDisabledLinkHelper = () => {
    const { resourceType, loan } = this.props;
    const { files } = this.props.document;
    const { borrowerType } = this.props.entity;
    const areTranscriptsOrderable = this.areTranscriptsOrderable(this.props);
    const noFiles = files.length === 0;
    const isCorporateGuarantor = borrowerType === 'corporate_guarantor';
    const showHelperForGuarantor =
      resourceType === 'Guarantor' &&
      !areTranscriptsOrderable &&
      borrowerType !== 'affiliate' &&
      noFiles;
    const showHelperForCorporateGuarantor =
      resourceType === 'Guarantor' &&
      !areTranscriptsOrderable &&
      isCorporateGuarantor &&
      loan.cre;
    if (showHelperForGuarantor || showHelperForCorporateGuarantor) {
      return (
        <DisabledLinkHelper>
          <DisabledTooltip>
            {this.getTooltipMessage(this.props)}
          </DisabledTooltip>
          Why can't I order transcripts?
        </DisabledLinkHelper>
      );
    }
  };
  isDocumentType4506 = (documentType) => {
    return (
      documentType === 'Document::T4506t' || documentType === 'Document::T4506c'
    );
  };
  renderTranscriptControls = () => {
    const { cre } = this.props.loan;
    const { type } = this.props.document;
    const { borrowerType } = this.props.entity;
    const isCorporateGuarantor = borrowerType === 'corporate_guarantor';
    const showControls =
      this.isDocumentType4506(type) && this.isNoTranscriptsFlow(this.props);
    const showControlsForCorporateGuarantor =
      isCorporateGuarantor && cre && showControls; // We only order transcripts for corporate guarantors on CRE loans
    const showControlsForAllOtherEntities =
      showControls && !isCorporateGuarantor;
    if (showControlsForAllOtherEntities || showControlsForCorporateGuarantor) {
      return (
        <Fragment>
          {this.renderOrderTranscriptsButton()}
          {this.renderDisabledLinkHelper()}
        </Fragment>
      );
    }
  };
  renderSuccessNotification = () => {
    if (this.state.isSuccessNotificationVisible) {
      return (
        <SuccessNotification
          duration={3}
          onClose={this.toggleSuccessNotification}
          text='Document successfully updated.'
        />
      );
    }
  };
  renderReferenceContainer = (referenceFiles) => {
    return referenceFiles.map((referenceDate) => (
      <Fragment key={`reference-${referenceDate.date}`}>
        {this.renderContainer(referenceDate)}
      </Fragment>
    ));
  };
  renderFileLink = (file) => {
    const { rid, fileUrls } = this.props.document;
    const fileUrl = fileUrls.find((f) => f.filename === file.name);

    return (
      <FileName key={`${file.name}-${rid}-${file.i}`}>
        <File className='fa fa-file-text-o'>
          &nbsp;
          <Link
            onClick={
              file.isNew ? () => this.onFilenameClick(file.name) : () => {}
            }
            href={fileUrl ? fileUrl.link : null}
            title={file.name}
            target='_blank'
            id='file_link'
          >
            {file.trimmedFilename}
          </Link>
        </File>
        {file.isNew && <New id='new_file_notification'>New</New>}
      </FileName>
    );
  };
  renderExpiredContainer = (files, referenceFiles) => {
    const dateList = referenceFiles.map(({ date }) => date);
    const dateSet = new Set(dateList);
    const expiredFiles = files.filter(
      ({ referenceDate }) => !dateSet.has(referenceDate)
    );

    return (
      <div id='document_bucket_box'>
        <Container>
          <b>EXPIRED DOCUMENTS</b>
        </Container>
        <LeftContainer>
          {expiredFiles.map((fileItem) => (
            <div key={`reference-${fileItem.uuid}`}>
              {this.renderFileLink(fileItem)}
            </div>
          ))}
        </LeftContainer>
      </div>
    );
  };
  renderContainer = (reference) => {
    const getTitle = () => {
      if (reference) {
        const { date } = reference;
        const dateFormat = this.getMomentDate(date).format('MMMM YYYY');
        return (
          <TitleContainerReference>
            {this.renderStatusFiles(reference)}
            <b>{dateFormat}</b>
          </TitleContainerReference>
        );
      }
      return null;
    };
    return (
      <div id='document_bucket_box'>
        {getTitle()}
        <Container>
          <LeftContainer>
            <DocumentControls>
              {this.renderFilenames(reference)}
              {this.renderControls(reference)}
              {this.renderTranscriptControls()}
            </DocumentControls>
          </LeftContainer>
          <RightContainer>{this.renderNote(reference)}</RightContainer>
          {this.renderEditModal()}
          {this.renderRejectedModal()}
          {this.renderDeleteModal()}
          {this.renderPrepareEsignModal()}
          {this.renderRequestSentModal()}
          {this.renderEsignUrlModal()}
          {this.renderSuccessNotification()}
          {this.renderCancelEsignModal()}
          {this.renderSignatureRequestStatusModal()}
          {this.renderSignatureRequestReminderModal()}
          {this.renderOrderTranscriptsModal()}
        </Container>
      </div>
    );
  };

  setTooltipHovered = (regenerate1919ButtonHover) => {
    this.setState({ regenerate1919ButtonHover });
  };

  get showRegenerate1919Button() {
    const {
      props: { document: doc },
    } = this;
    const { type } = doc;

    return type === 'Document::T1919Business';
  }

  get disableRegenerate1919Button() {
    const {
      props: { document: doc },
    } = this;
    const { status } = doc;

    return status === 'approve_and_commit';
  }

  get hasReferences() {
    const { document: doc } = this.props;
    let { referenceFiles } = doc;
    referenceFiles = JSON.parse(referenceFiles);

    return referenceFiles.length > 0;
  }
  get showExpiredDocument() {
    const {
      props: { document: doc },
      hasReferences,
    } = this;
    const { type } = doc;

    return type === 'Document::BankStatement' && hasReferences;
  }

  get display1919TooltipCopy() {
    const { disableRegenerate1919Button } = this;

    return disableRegenerate1919Button
      ? 'You must un-approve the document to regenerate'
      : 'Regenerate Document';
  }

  render1919StatusIcon = (status) => {
    const documentStatusDictionary = {
      success: {
        iconClass: 'check',
        color: '#339952',
      },
      loading: {
        color:'#CFD8DC',

      },
      error: {
        iconClass: 'exclamation',
        color: '#BC3C4B',
      },
    };
    const { iconClass, color } = documentStatusDictionary[status] || {};
    const isLoading = status === 'loading';

    return (
      <DocumentIcon
      loading={isLoading}
      className={`fa fa-${iconClass}`}
      color={color}
      fontSize="9pt"
      height="20px"
      width="20px"
      >
      </DocumentIcon>
    )
  }

  renderRegenerate1919Button = (
    disableRegenerate1919Button,
    display1919TooltipCopy,
    regenerate1919ButtonHover
  ) => {
    const { render1919StatusIcon } = this;
    const { documentStatus1919 } = this.state;
    const isDocument1919Idle = documentStatus1919 === 'idle';

    const showRegenerateButton = () => (
      <>
        <Regenerate1919Button
          className={`${disableRegenerate1919Button ? 'disabled' : ''}`}
          onMouseOver={() => this.setTooltipHovered(true)}
          onMouseOut={() => this.setTooltipHovered(false)}
          onClick={() => this.update1919s()}
          disabled={disableRegenerate1919Button}
        >
          <RegenerateIcon className='fa fa-refresh' />
        </Regenerate1919Button>
        {regenerate1919ButtonHover && (
          <Tooltip topArrow={true} bottomEdge={-48} left={-53}>
            {display1919TooltipCopy}
          </Tooltip>
        )}
      </>
    )

    return (
      <TooltipContainer>
            {isDocument1919Idle ? showRegenerateButton() : render1919StatusIcon(documentStatus1919)}
      </TooltipContainer>
    );
  }

  render() {
    const {
      hasReferences,
      disableRegenerate1919Button,
      display1919TooltipCopy,
      showExpiredDocument,
      showRegenerate1919Button,
      renderRegenerate1919Button,
      props: { resourceType, document: doc },
      state: { errorMessage, regenerate1919ButtonHover },
    } = this;
    const { title, adminOnly, deletable, confirmed, type, files, rid, status } =
      doc;
    let { referenceFiles } = doc;
    referenceFiles = JSON.parse(referenceFiles);
    const is4506 = this.isDocumentType4506(type);
    // Delete icon should be visible if the document is deletable or if it's a 4506T bucket with at least one file in it
    const isDeleteIconVisible = is4506 ? files.length > 0 : deletable;

    return (
      <ContainerBucket id='document_bucket_container'>
        {this.renderStatusIcon()}
        <ContainerInfo>
          <ErrorMessages>{errorMessage}</ErrorMessages>
          <TitleContainer>
            <DropdowContainer>
              {this.renderStatus(hasReferences)}
              {showRegenerate1919Button &&
                renderRegenerate1919Button(
                  disableRegenerate1919Button,
                  display1919TooltipCopy,
                  regenerate1919ButtonHover
                )}
            </DropdowContainer>
            <Title>
              <b id={`document_title_${rid}`}>
                {title}
                {resourceType !== 'Archived' && (
                  <Fragment>
                    {!confirmed && type !== 'Document::t4506T' && (
                      <Icon
                        onClick={() =>
                          this.toggleState('isDocumentBucketModalOpen')
                        }
                        className='fa fa-pencil'
                        id='edit_bucket'
                      />
                    )}
                    {isDeleteIconVisible && (
                      <Icon
                        onClick={() => this.toggleState('isDeleteModalOpen')}
                        className='fa fa-trash'
                        id='delete_bucket'
                      />
                    )}
                  </Fragment>
                )}
              </b>
              <Grey>{`${adminOnly ? 'Admin' : 'Borrower'} Document`}</Grey>
            </Title>
          </TitleContainer>
          {hasReferences
            ? this.renderReferenceContainer(referenceFiles)
            : this.renderContainer()}
          {showExpiredDocument &&
            this.renderExpiredContainer(files, referenceFiles)}
        </ContainerInfo>
      </ContainerBucket>
    );
  }
}

export { FinancialDocument };

export default compose(
  graphql(Regenerate1919sMutation, {
    name: 'regenerate1919s',
  }),
  graphql(UpdateDocumentStatus, {
    name: 'updateDocumentStatus',
  }),
  graphql(UpdateDocumentFileStatus, {
    name: 'updateDocumentFileStatus',
  }),
  graphql(MarkFileAsRead, {
    name: 'markFileAsRead',
  }),
  graphql(UpdateDocumentComment, {
    name: 'updateDocumentComment',
  }),
  WithLoan,
  withApollo
)(FinancialDocument);
